module.exports = __webpack_public_path__ + "img/multimedia.0abadf39.svg";